import * as React from 'react';
import type {Key} from '@react-types/shared';
import type {ItemDesc} from '@sail/react-aria';

const collectionGroupKey = Symbol('collectionGroupKey');

// Collection registration order can change when groups are rendered through
// another component, so items retain an explicit link to their parent group.
export const CollectionGroupContext = React.createContext<Key | undefined>(
  undefined,
);

export const withCollectionGroup = (
  item: ItemDesc,
  groupKey: Key | undefined,
): ItemDesc => {
  if (groupKey === undefined) {
    return item;
  }

  const data =
    typeof item.data === 'object' && item.data !== null ? item.data : {};
  return {...item, data: {...data, [collectionGroupKey]: groupKey}};
};

export const getCollectionGroupKey = (data: unknown): Key | undefined => {
  if (typeof data !== 'object' || data === null) {
    return undefined;
  }

  return (data as {[collectionGroupKey]?: Key})[collectionGroupKey];
};
